import { useQuery } from '@tanstack/react-query';
import { useToast } from '@chakra-ui/react';
import { fetchArticleDetail } from '../article.api';

export const useArticleQuery = (articleId: string) => {
  const toast = useToast();

  const query = useQuery({
    queryKey: ['article', articleId],
    queryFn: async () => {
      const data = await fetchArticleDetail(articleId);
      return data;
    },
    enabled: !!articleId,
    // Prevent duplicate refetches when multiple components mount and use the same query
    staleTime: 60 * 1000, // consider fresh for 1 minute
    refetchOnMount: false,
    refetchOnWindowFocus: false,
    refetchOnReconnect: false
  });

  if (query.isError) {
    console.error('Error fetching article:', query.error);
    toast({
      title: "Couldn't load article",
      status: 'error',
      position: 'top-right',
      isClosable: true
    });
  }

  return query;
};
